import * as React from "react"

import { cn } from "@/lib/utils"

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "border border-primary/20 bg-card/95 placeholder:text-muted-foreground aria-invalid:border-destructive dark:border-border dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md px-3.5 py-2.5 shadow-xs transition-[color,box-shadow] outline-none disabled:cursor-not-allowed disabled:opacity-50 dark:shadow-none",
        "focus-visible:border-primary/45 dark:focus-visible:border-muted-foreground/40",
        className
      )}
      style={{
        fontSize: '16px',
        ...props.style
      }}
      {...props}
    />
  )
}

export { Textarea }
